const menuActionsTypes = {
    OPEN_MENU: 'OPEN_MENU',
    CLOSE_MENU: 'CLOSE_MENU'
}

export default menuActionsTypes;